<template>
  <footer
    class="w-full rounded-t-[2.5rem] md:rounded-t-[3.75rem] bg-[#222b3c] py-10 lg:py-24 text-xs lg:text-[0.9375rem] mt-10"
  >
    <div
      class="max-w-[75rem] mx-auto flex items-center divide-x divide-neutral-400 max-md:justify-center"
    >
      <router-link to="/introduce/1" class="text-neutral-400 pr-5 leading-none"
        >총회교육개발원 소개</router-link
      >
      <router-link to="/introduce/5" class="text-neutral-400 px-5 leading-none"
        >찾아오시는길</router-link
      >
      <router-link
        to="/policy/info"
        class="text-white font-medium pl-5 leading-none"
      >
        개인정보취급방침
      </router-link>
    </div>

    <div
      class="max-w-[75rem] mx-auto flex max-md:flex-col justify-between mt-10 gap-10"
    >
      <div class="flex flex-col gap-y-1">
        <p class="text-neutral-400">
          (06177) 서울특별시 강남구 영동대로 330(대치동) 총회회관 6층
          총회교육개발원
        </p>
        <p
          class="flex md:items-center gap-x-2 text-neutral-400 max-md:flex-col"
        >
          대표전화 02)559-5643
          <span class="max-md:hidden"
            ><svg
              width="1"
              height="9"
              viewBox="0 0 1 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 0V9" stroke="#a3a3a3" />
            </svg>
          </span>
          이메일 eduwind.org@gmail.com
        </p>
        <p
          class="flex md:items-center gap-x-2 text-neutral-400 max-md:flex-col"
        >
          (재)대한예수교장로회총회
          <span class="max-md:hidden"
            ><svg
              width="1"
              height="9"
              viewBox="0 0 1 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 0V9" stroke="#a3a3a3" />
            </svg>
          </span>
          대표자 장봉생
          <span class="max-md:hidden"
            ><svg
              width="1"
              height="9"
              viewBox="0 0 1 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 0V9" stroke="#a3a3a3" />
            </svg>
          </span>
          사업자등록번호 120-82-00479
        </p>
        <p class="text-neutral-400">통신판매업신고번호 강남-1505</p>
        <p class="text-neutral-400 mt-6">
          Copyright © 총회교육.com. All rights reserved.
        </p>
      </div>

      <div class="flex flex-col items-end max-lg:items-baseline">
        <p class="w-fit font-medium border border-white rounded-full px-5 py-1">
          CS CENTER
        </p>
        <h1 class="font-bold leading-tight">02-559-5643</h1>
        <a href="https://pf.kakao.com/_YqHmu/chat" target="_blank" class="text-lg font-medium cursor-pointer">고객센터 바로가기</a>
        <div
          class="flex divide-x divide-neutral-400 text-neutral-400 leading-none mt-4"
        >
          <p class="px-2">평일 10:00~17:00</p>
          <p class="px-2">주말·공휴일 휴무</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup></script>
